// extracted by mini-css-extract-plugin
export var icon = "_4x-1";
export var subtext = "_4x-0";